import { render, staticRenderFns } from "./VueLoad.vue?vue&type=template&id=4a54575b"
import script from "./VueLoad.vue?vue&type=script&lang=js"
export * from "./VueLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports